import { render } from "./mvt-hotleadform.vue?vue&type=template&id=4e770180"
import script from "./mvt-hotleadform.js?vue&type=script&lang=js"
export * from "./mvt-hotleadform.js?vue&type=script&lang=js"

import "./mvt-hotleadform.vue?vue&type=style&index=0&id=4e770180&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__